import type { SVGProps } from 'react';

const EditIconOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    {...props}
  >
    <path d="M3.60002 12.4H4.45002L10.7 6.14999L9.85002 5.29999L3.60002 11.55V12.4ZM3.00302 13.6C2.83436 13.6 2.69169 13.5428 2.57502 13.4283C2.45836 13.314 2.40002 13.1722 2.40002 13.003V11.5555C2.40002 11.3963 2.4278 11.2444 2.48336 11.1C2.53891 10.9555 2.6278 10.8222 2.75002 10.7L10.7 2.74999C10.8222 2.62777 10.9547 2.53888 11.0974 2.48333C11.2399 2.42777 11.3899 2.39999 11.5474 2.39999C11.7047 2.39999 11.8556 2.42777 12 2.48333C12.1445 2.53888 12.2778 2.62777 12.4 2.74999L13.25 3.59999C13.3722 3.72222 13.4611 3.85555 13.5167 3.99999C13.5722 4.14444 13.6 4.29188 13.6 4.44233C13.6 4.60288 13.5721 4.75588 13.5164 4.90133C13.4606 5.04677 13.3718 5.17966 13.25 5.29999L5.30002 13.25C5.1778 13.3722 5.04475 13.4611 4.90086 13.5167C4.75697 13.5722 4.60564 13.6 4.44686 13.6H3.00302ZM10.2675 5.73249L9.85002 5.29999L10.7 6.14999L10.2675 5.73249Z" />
  </svg>
);

export default EditIconOutline;
